import {
  FetchNextPageOptions,
  InfiniteQueryObserverResult,
  InfiniteData,
} from '@tanstack/query-core';
import { CartHistoryFooter, ExtensionMissingModal } from 'src/components';
import {
  CartsDisplayEmpty,
  CartsDisplayGrid,
  CartsDisplayList,
} from './cartDisplayBlocks';
import type { CartHistoryData } from 'src/types';

/**
 * TODO - this component is a mess, I need to refactor it
 */

type Props = {
  cartsList:
    | {
        carts: CartHistoryData[];
        pageParam: number;
      }[]
    | undefined;
  displayedCartsLength: number;
  isListView: boolean;
  queryError: boolean;
  loadMoreCarts: (options?: FetchNextPageOptions | undefined) => Promise<
    InfiniteQueryObserverResult<
      InfiniteData<
        {
          carts: CartHistoryData[];
          pageParam: number;
        },
        unknown
      >,
      Error
    >
  >;
  fetchingNextPage: boolean;
  hasNextPage: boolean;
};

export const CartsDisplay = ({
  cartsList,
  displayedCartsLength,
  isListView,
  queryError,
  loadMoreCarts,
  fetchingNextPage,
  hasNextPage,
}: Props) => {
  return (
    <div className='w-full bg-white font-primary text-primary-dark'>
      {cartsList && displayedCartsLength !== 0 && !queryError ? (
        <>
          {isListView ? (
            <CartsDisplayList
              cartsList={cartsList}
              fetchingNextPage={fetchingNextPage}
            />
          ) : (
            <CartsDisplayGrid
              cartsList={cartsList}
              fetchingNextPage={fetchingNextPage}
            />
          )}
          <CartHistoryFooter
            displayedCartsLength={displayedCartsLength}
            hasNextPage={hasNextPage}
            fetchingNextPage={fetchingNextPage}
            loadMoreCarts={loadMoreCarts}
          />
        </>
      ) : (
        <CartsDisplayEmpty
          displayedCartsLength={displayedCartsLength}
          queryError={queryError}
        />
      )}
      <ExtensionMissingModal forImport={true} />
    </div>
  );
};
